import React from 'react'
import clsx from 'clsx'

import BaseModal from '../BaseModal2'
import Button from '../../../atoms/Button2'
import ButtonSecondary from '../../../atoms/ButtonSecondary'

import useStyles from './styles'

type AreYouSureModalProps = {
  onClose: () => void
  onAccept: () => void
  title?: React.ReactNode
  reason: React.ReactNode
  subtext: React.ReactNode
}

const AreYouSureModal: React.FC<AreYouSureModalProps> = ({
  onClose,
  onAccept,
  title = 'DISCARD CHANGES?',
  reason = 'Are you sure you want to leave this page?',
  subtext = 'Continuing will discard those changes'
}) => {
  const classes = useStyles()

  return (
    <BaseModal
      open
      hideTitle
      showX={false}
      onClose={onClose}
      mobileFullSize={false}
    >
      <div className={classes.root}>
        <div className={classes.title}>{title}</div>

        <div className={classes.subtext}>
          {reason} <br />
          {subtext}
        </div>

        <div className={classes.buttons}>
          <div className={classes.noButton}>
            <Button onClick={onClose} className={clsx(classes.button)}>
              No
            </Button>

            <div className={classes.helperButtonText}>
              <label>Go back</label>
            </div>
          </div>

          <div>
            <ButtonSecondary
              onClick={onAccept}
              className={clsx(classes.button, classes.yesButton)}
            >
              Yes
            </ButtonSecondary>

            <div className={classes.helperButtonText}>
              <label>Continue</label>
            </div>
          </div>
        </div>
      </div>
    </BaseModal>
  )
}

export default AreYouSureModal
